"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[110],{

/***/ 3340:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _IconListItem__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7731);


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var IconList = function(props) {
    var _align = props.align, align = _align === void 0 ? 'horizontal' : _align, children = props.children, className = props.className, _data = props.data, data = _data === void 0 ? [] : _data, rest = _objectWithoutProperties(props, [
        "align",
        "children",
        "className",
        "data"
    ]);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", _objectSpread({
        className: [
            'c-icon-list',
            "c-icon-list-".concat(align),
            className
        ].filter(function(item) {
            return item;
        }).join(' ')
    }, rest, {
        children: [
            data.map(function(icon, index) {
                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_IconListItem__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, _objectSpread({}, icon), index);
            }),
            children
        ]
    })));
};
/* harmony default export */ __webpack_exports__["Z"] = (IconList);


/***/ }),

/***/ 7731:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _components_base_anchor__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5900);
/* harmony import */ var _components_base_icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2676);



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var IconListItem = function(props) {
    var icon = props.icon, text = props.text, anchor = props.anchor, rest = _objectWithoutProperties(props, [
        "icon",
        "text",
        "anchor"
    ]);
    var Body = function() {
        if (text) {
            return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({}, icon))
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "c-iconlist-item-label",
                            children: text
                        })
                    })
                ]
            }));
        }
        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({}, icon)));
    };
    if (anchor) {
        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_anchor__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, _objectSpread({
            className: "c-iconlist-item-anchor",
            title: text
        }, anchor, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Body, {})
        })));
    }
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", _objectSpread({
        className: "c-iconlist-item"
    }, rest, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Body, {})
    })));
};
/* harmony default export */ __webpack_exports__["Z"] = (IconListItem);


/***/ }),

/***/ 4360:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _IconList__WEBPACK_IMPORTED_MODULE_0__.Z; },
/* harmony export */   "M": function() { return /* reexport safe */ _IconListItem__WEBPACK_IMPORTED_MODULE_1__.Z; }
/* harmony export */ });
/* harmony import */ var _IconList__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3340);
/* harmony import */ var _IconListItem__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7731);




/***/ }),

/***/ 8110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ footer_Footer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./core/contexts/app/index.tsx + 1 modules
var contexts_app = __webpack_require__(9617);
// EXTERNAL MODULE: ./core/hooks/useWidthResize.ts
var useWidthResize = __webpack_require__(4546);
// EXTERNAL MODULE: ./components/base/gridview/index.tsx + 4 modules
var gridview = __webpack_require__(7923);
// EXTERNAL MODULE: ./components/base/anchor/index.tsx
var base_anchor = __webpack_require__(5900);
// EXTERNAL MODULE: ./components/base/image/index.tsx
var base_image = __webpack_require__(6475);
// EXTERNAL MODULE: ./components/base/icon-list/index.ts
var icon_list = __webpack_require__(4360);
// EXTERNAL MODULE: ./node_modules/begonya/functions/index.js
var functions = __webpack_require__(44);
;// CONCATENATED MODULE: ./components/widgets/footer/Footer.tsx









function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var Footer = function(props) {
    var ref, ref1, ref2, ref3;
    var app = (0,contexts_app/* useApp */.qD)();
    var width = (0,useWidthResize/* useWidth */.z)();
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
        className: "footer",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(gridview/* Container */.W2, {
                size: "medium",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(gridview/* Row */.X2, {
                    className: "footer-top-wrapper",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(gridview/* Column */.sg, {
                            xs: {
                                size: 12
                            },
                            sm: {
                                size: 12
                            },
                            md: {
                                size: 12
                            },
                            lg: {
                                size: 3
                            },
                            xl: {
                                size: 3
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(base_anchor/* default */.Z, {
                                    className: "footer-top-wrapper-logo",
                                    href: app.settings.homepage,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(base_image["default"], _objectSpread({}, ((ref = props.logo) === null || ref === void 0 ? void 0 : ref.src) ? props.logo : app.theme.logo, {
                                        alt: app.page.title,
                                        height: 50
                                    }))
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "title",
                                    children: "\xc7ağrı Merkezi"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "tel:".concat(props.phone),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: props.phone
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(gridview/* Column */.sg, {
                            xs: {
                                size: 12
                            },
                            sm: {
                                size: 12
                            },
                            md: {
                                size: 12
                            },
                            lg: {
                                size: 6
                            },
                            xl: {
                                size: 6
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                                className: "footer-top-wrapper-menu",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    children: (ref1 = props.navigation) === null || ref1 === void 0 ? void 0 : ref1.map(function(menuItem, index) {
                                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("li", {
                                            className: (0,functions.classnames)(menuItem.className, menuItem.children.length && 'hasSubMenu'),
                                            children: [
                                                menuItem.children.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(base_anchor/* default */.Z, {
                                                    onClick: function(e) {
                                                        return e.preventDefault();
                                                    },
                                                    children: menuItem.title
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(base_anchor/* default */.Z, {
                                                    href: menuItem.href,
                                                    dangerouslySetInnerHTML: {
                                                        __html: menuItem.title
                                                    }
                                                }),
                                                menuItem.children.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                    className: "sub-menu",
                                                    children: menuItem.children.map(function(subItem, subIndex) {
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(base_anchor/* default */.Z, {
                                                                href: subItem.href,
                                                                children: subItem.title
                                                            })
                                                        }, subIndex);
                                                    })
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                            ]
                                        }, index);
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(gridview/* Column */.sg, {
                            xs: {
                                size: 12
                            },
                            sm: {
                                size: 12
                            },
                            md: {
                                size: 12
                            },
                            lg: {
                                size: 3
                            },
                            xl: {
                                size: 3
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "footer-top-wrapper-contacts",
                                    children: (ref2 = props.contacts) === null || ref2 === void 0 ? void 0 : ref2.map(function(item, index) {
                                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                            className: "contacts-item",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "title",
                                                    children: item.title
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: item.address
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "tel:".concat(item.phone),
                                                    children: item.phone
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "mailto:".concat(item.email),
                                                    children: item.email
                                                })
                                            ]
                                        }, index);
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "footer-top-wrapper-social-media",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(icon_list/* default */.Z, {
                                        className: "footer-social-media-list",
                                        children: [
                                            app.settings.socials['facebook'] && /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_list/* IconListItem */.M, {
                                                icon: {
                                                    name: 'icon-facebook',
                                                    onClick: function() {
                                                        return window.open(app.settings.socials['facebook'] || 'https://www.facebook.com/asggrup', '_blank');
                                                    },
                                                    style: {
                                                        cursor: 'pointer'
                                                    }
                                                }
                                            }),
                                            app.settings.socials['twitter'] && /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_list/* IconListItem */.M, {
                                                icon: {
                                                    name: 'icon-twitter',
                                                    onClick: function() {
                                                        return window.open(app.settings.socials['twitter'] || 'https://www.twitter.com/asggrup', '_blank');
                                                    },
                                                    style: {
                                                        cursor: 'pointer'
                                                    }
                                                }
                                            }),
                                            app.settings.socials['instagram'] && /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_list/* IconListItem */.M, {
                                                icon: {
                                                    name: 'icon-instagram',
                                                    onClick: function() {
                                                        return window.open(app.settings.socials['instagram'] || 'https://www.instagram.com/asggrup/', '_blank');
                                                    },
                                                    style: {
                                                        cursor: 'pointer'
                                                    }
                                                }
                                            }),
                                            app.settings.socials['youtube'] && /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_list/* IconListItem */.M, {
                                                icon: {
                                                    name: 'icon-youtube',
                                                    onClick: function() {
                                                        return window.open(app.settings.socials['youtube'] || 'https://www.linkedin.com/asggrup', '_blank');
                                                    },
                                                    style: {
                                                        cursor: 'pointer'
                                                    }
                                                }
                                            }),
                                            app.settings.socials['linkedin'] && /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_list/* IconListItem */.M, {
                                                icon: {
                                                    name: 'icon-linkedin2',
                                                    onClick: function() {
                                                        return window.open(app.settings.socials['linkedin'] || 'https://www.linkedin.com/asggrup', '_blank');
                                                    },
                                                    style: {
                                                        cursor: 'pointer'
                                                    }
                                                }
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(gridview/* Container */.W2, {
                size: "medium",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(gridview/* Row */.X2, {
                    className: "footer-bottom-wrapper",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(gridview/* Column */.sg, {
                            className: "footer-bottom-wrapper-copyright",
                            xs: {
                                size: 12,
                                order: 'last'
                            },
                            sm: {
                                size: 12,
                                order: 'last'
                            },
                            md: {
                                size: 6,
                                order: 'first'
                            },
                            lg: {
                                size: 6,
                                order: 'first'
                            },
                            xl: {
                                size: 6,
                                order: 'first'
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    dangerouslySetInnerHTML: {
                                        __html: app.settings.translations['designby']
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    dangerouslySetInnerHTML: {
                                        __html: app.settings.translations['copyright']
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(gridview/* Column */.sg, {
                            className: "footer-bottom-wrapper-policy-menu",
                            xs: {
                                size: 12,
                                order: 'first'
                            },
                            sm: {
                                size: 12,
                                order: 'first'
                            },
                            md: {
                                size: 6,
                                order: 'last'
                            },
                            lg: {
                                size: 6,
                                order: 'last'
                            },
                            xl: {
                                size: 6,
                                order: 'last'
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                children: props === null || props === void 0 ? void 0 : (ref3 = props.policyNavigation) === null || ref3 === void 0 ? void 0 : ref3.map(function(menuItem, index) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                        className: menuItem.className,
                                        children: menuItem.href.indexOf('http') === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: menuItem.href,
                                            target: menuItem.target,
                                            dangerouslySetInnerHTML: {
                                                __html: menuItem.title
                                            },
                                            rel: "noreferrer"
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(base_anchor/* default */.Z, {
                                            href: menuItem.href,
                                            dangerouslySetInnerHTML: {
                                                __html: menuItem.title
                                            }
                                        })
                                    }, index);
                                })
                            })
                        })
                    ]
                })
            })
        ]
    }));
};
/* harmony default export */ var footer_Footer = (Footer);

;// CONCATENATED MODULE: ./components/widgets/footer/index.tsx



/***/ })

}]);